import { Suspense, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { closeDialog } from "../../redux/reducer/dialogSlice";
import { AppBar, Dialog, IconButton, Toolbar, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import PageLoader from "../loader/LoaderText";


const dialogComponents: Record<string, React.LazyExoticComponent<React.FC>> = {
    // hospital:'',
    // Add other dialog components here
    
};

const CommonDialogComponent = () => {

    const [mounted, setMounted] = useState(false);
    const dispatch = useDispatch();
    const { isOpen, isFullScreen, title, size, moduleType } = useSelector((state: RootState) => state.dialog);

    const handleClose = useCallback(() => {
        dispatch(closeDialog());
        setMounted(false);
    }, [dispatch]);

    useEffect(() => {
        if (isOpen && !mounted) { setMounted(true); }
    }, [isOpen, mounted]);

    const DialogComponent = moduleType ? dialogComponents[moduleType] : null;

    return (
        <Dialog open={isOpen} fullScreen={isFullScreen ?? false} fullWidth={true} maxWidth={size as 'xs' | 'sm' | 'md' | 'lg' | 'xl' ?? 'md'}>
            {isFullScreen && <AppBar elevation={7} sx={{ position: 'relative', height: '59px' }}>
                <Toolbar sx={{display: 'flex', alignItems: 'center' , justifyContent: 'space-between'}}>
                    <Typography sx={{ flex: 1 }} variant="h5" fontWeight={"h4.fontWeight"} component="div">{title}</Typography>
                    <IconButton edge="start" color="inherit" onClick={handleClose}> <CloseIcon /> </IconButton>
                </Toolbar>
            </AppBar>}

            <Suspense fallback={<PageLoader />}>
                {DialogComponent ? <DialogComponent /> : null}
            </Suspense>

        </Dialog>
    )
}
export default CommonDialogComponent